import mutations from './mutations';
import api from '../api';

export default {
  namespaced: true,
  state: {
    loading: false
  },
  mutations: {
    [mutations.LOADING](state) {
      state.loading = true;
    },
    [mutations.LOADED](state) {
      state.loading = false;
    }
  },
  actions: {
    getConsolidatePO({ commit }, params = {}) {
      commit(mutations.LOADING);
      return api.monthlyReport
        .getConsolidatePO(params)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(error => {
          commit(mutations.LOADED);
          return error;
        });
    },
    uploadPO({ commit }, { payload, params }) {
      commit(mutations.LOADING);
      return api.monthlyReport
        .uploadPO(payload, params)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(error => {
          commit(mutations.LOADED);
          return error;
        });
    },
    uploadIO({ commit }, { payload, params }) {
      commit(mutations.LOADING);
      return api.monthlyReport
        .uploadIO(payload, params)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(error => {
          commit(mutations.LOADED);
          return error;
        });
    },
    editPO({ commit }, { id, params }) {
      commit(mutations.LOADING);
      return api.monthlyReport
        .editPO(id, params)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(err => {
          commit(mutations.LOADED);
          return err;
        });
    },
    editIO({ commit }, { id, params }) {
      commit(mutations.LOADING);
      return api.monthlyReport
        .editIO(id, params)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(err => {
          commit(mutations.LOADED);
          return err;
        });
    },
    getConsolidateIO({ commit }, params = {}) {
      commit(mutations.LOADING);
      return api.monthlyReport
        .getConsolidateIO(params)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(error => {
          commit(mutations.LOADED);
          return error;
        });
    },
    getSummary({ commit }, params = {}) {
      commit(mutations.LOADING);
      return api.monthlyReport
        .getSummary(params)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(error => {
          commit(mutations.LOADED);
          return error;
        });
    },
    getTemplate({ commit }, params = {}) {
      commit(mutations.LOADING);
      return api.monthlyReport
        .getTemplate(params)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(error => {
          console.log(error);
          commit(mutations.LOADED);
          return error;
        });
    }
  }
};
